"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_module_1 = require("./app/app.module");
const environment_ts_1 = require("../../service-lib/src/lib/environment.ts");
const common_bootstrap_1 = require("../../service-lib/src/lib/common-bootstrap"); //import global bootstrap setup from service-lib
async function bootstrap() {
    const commonBootstrap = new common_bootstrap_1.CommonBootstrap();
    const port = environment_ts_1.ENV.PORT_ORG_SERVICE ? parseInt(environment_ts_1.ENV.PORT_ORG_SERVICE, 10) : 3023;
    const gatewayUrl = environment_ts_1.ENV.URL_API_GATEWAY;
    await commonBootstrap.bootstrap(port, app_module_1.AppModule, 'Organization Service', gatewayUrl, "org-service");
}
bootstrap();
